import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link, NavLink } from 'react-router-dom';
import { Collapse, Navbar, Nav, NavItem } from 'reactstrap';
import logo from '../../../assets/images/dominionLogo.svg';
import './Header.scss';
import { FormattedMessage } from 'react-intl';

const Header = ({
  page,
  zipcode,
  activePage,
  userLocation,
  language,
  changeLanguage,
}) => {
  const [collapse, setCollapse] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const isHomepage =
    window.location.pathname === '/' || window.location.pathname === null;

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header className="Header">
      <div className="container-fluid" style={{ padding: 0 }}>
        <Navbar expand="lg">
          <div
            className="logo"
            style={{
              paddingTop: '0.75rem',
              paddingBottom: '0.75rem',
            }}
          >
            <Link to="/" className={isHomepage ? 'active' : ''}>
              <img
                src={logo}
                className="homepagelogo"
                alt="{process.env.REACT_APP_FULL_COMPANY_NAME}"
              />
            </Link>
          </div>
          <div
            className="custom-toggler"
            onClick={() => setCollapse(!collapse)}
            aria-label="Toggle Dropdown"
          >
            {collapse ? (
              <div className="hamburger open">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            ) : (
              <div className="hamburger">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            )}
          </div>
          <Collapse isOpen={collapse} navbar>
            <Nav navbar>
              <NavItem>
                <Link to="/" className={activePage === '' ? 'active' : ''}>
                  <span className="mobile-header-item">
                    <FormattedMessage
                      id="header.home"
                      defaultMessage="Home"
                      description="Home page"
                    />
                  </span>
                </Link>
              </NavItem>
              {isMobile ? (
                <>
                  <NavItem>
                    <Link to="/vehicles">
                      <span className="mobile-header-item">
                        <FormattedMessage
                          id="header.electricVehicles.browse"
                          defaultMessage="Browse Models"
                        />
                      </span>
                    </Link>
                  </NavItem>
                  <NavItem>
                    <Link to="/compare-vehicles">
                      <span className="mobile-header-item">
                        <FormattedMessage
                          id="header.electricVehicles.compare"
                          defaultMessage="Browse Models"
                        />
                      </span>
                    </Link>
                  </NavItem>
                </>
              ) : (
                <NavItem>
                  <div
                    className="dropdown-container"
                    onClick={() => setOpenDropdown(openDropdown === 'ev' ? null : 'ev')}
                  >
                    <span className="mobile-header-item">
                      <FormattedMessage
                        id="header.electricVehicles"
                        defaultMessage="Browse EVs"
                        description="Shop Electric Header"
                      />
                    </span>
                    {openDropdown === 'ev' && (
                      <div className="dropdown-wrapper">
                        <Link to="/vehicles">
                          <span className="mobile-header-item">
                            <FormattedMessage
                              id="header.electricVehicles.browse"
                              defaultMessage="Browse Models"
                            />
                          </span>
                        </Link>

                        <Link to="/compare-vehicles">
                          <span className="mobile-header-item">
                            <FormattedMessage
                              id="header.electricVehicles.compare"
                              defaultMessage="Browse Models"
                            />
                          </span>
                        </Link>
                      </div>
                    )}
                  </div>
                </NavItem>
              )}
              <NavItem>
                <NavLink
                  title={page === 'incentives' ? 'Active Page' : null}
                  to="/incentives"
                >
                  <span className="mobile-header-item">
                    <FormattedMessage
                      id="header.incentives"
                      defaultMessage="Incentives"
                      description="Incentives Header"
                    />
                  </span>
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  title={page === 'incentives' ? 'Active Page' : null}
                  to="/rates"
                >
                  <span className="mobile-header-item">
                    <FormattedMessage
                      id="header.rates"
                      defaultMessage="Rates"
                      description="Rates Header"
                    />
                  </span>
                </NavLink>
              </NavItem>
              {isMobile ? (
                <>
                  <NavItem>
                    <Link to="/charging-stations">
                      <span className="mobile-header-item">
                        <FormattedMessage
                          id="header.chargingStations"
                          defaultMessage="Charging Stations"
                          description="Charging Stations Header"
                        />
                      </span>
                    </Link>
                  </NavItem>
                  <NavItem>
                    <Link to="/home-chargers">
                      <span className="mobile-header-item">
                        <FormattedMessage
                          id="'header.homeChargers"
                          defaultMessage="Home Chargers Catalog"
                          description="Home Chargers Header"
                        />
                      </span>
                    </Link>
                  </NavItem>
                </>
              ) : (
                <NavItem>
                  <div
                    className="dropdown-container"
                    onClick={() => setOpenDropdown(openDropdown === 'charging' ? null : 'charging')}
                  >
                    <span className="mobile-header-item">
                      <FormattedMessage
                        id="header.charging"
                        defaultMessage="Charging"
                        description="Charging Header"
                      />
                    </span>
                    {openDropdown === 'charging' && (
                      <div className="dropdown-wrapper">
                        <Link to="/charging-stations">
                          <span className="mobile-header-item">
                            <FormattedMessage
                              id="header.chargingStations"
                              defaultMessage="Charging Stations"
                              description="Charging Stations Header"
                            />
                          </span>
                        </Link>

                        <Link to="/home-chargers">
                          <span className="mobile-header-item">
                            <FormattedMessage
                              id="'header.homeChargers"
                              defaultMessage="Home Chargers Catalog"
                              description="Home Chargers Header"
                            />
                          </span>
                        </Link>
                      </div>
                    )}
                  </div>
                </NavItem>
              )}
              {isMobile ? (
                <>
                  <NavItem>
                    <Link to="/ev-101">
                      <span className="mobile-header-item">
                        <FormattedMessage
                          id="header.learnMore.101"
                          defaultMessage="Browse Models"
                        />
                      </span>
                    </Link>
                  </NavItem>
                  <NavItem>
                    <Link to="/emissions">
                      <span className="mobile-header-item">
                        <FormattedMessage
                          id="header.learnMore.emissions"
                          defaultMessage="Browse Models"
                        />
                      </span>
                    </Link>
                  </NavItem>
                </>
              ) : (
                <NavItem>
                  <div
                    className="dropdown-container"
                    onClick={() => setOpenDropdown(openDropdown === 'more' ? null : 'more')}
                  >
                    <span className="mobile-header-item">
                      <FormattedMessage
                        id="header.learnMore"
                        defaultMessage="Browse EVs"
                        description="Shop Electric Header"
                      />
                    </span>
                    {openDropdown === 'more' && (
                      <div className="dropdown-wrapper learn-more">
                        <Link to="/ev-101">
                          <span className="mobile-header-item">
                            <FormattedMessage
                              id="header.learnMore.101"
                              defaultMessage="Browse Models"
                            />
                          </span>
                        </Link>

                        <Link to="/emissions">
                          <span className="mobile-header-item">
                            <FormattedMessage
                              id="header.learnMore.emissions"
                              defaultMessage="Browse Models"
                            />
                          </span>
                        </Link>
                      </div>
                    )}
                  </div>
                </NavItem>
              )}
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    </header>
  );
};

export default Header;

Header.propTypes = {
  page: PropTypes.string,
};
